import { RiskBadge } from '@/components/ui/Badge'
import { LatencyBar } from '@/components/ui/LatencyBar'
import { formatCount, formatMs, formatPercent } from '@/lib/utils/format'
import type { ToolPerformance } from '@/types/domain'

export function ToolPerformanceTable({ tools }: { tools: ToolPerformance[] }) {
  const scaleMs = Math.max(...tools.map((tool) => tool.latency.p95_ms), 1)

  return (
    <div className="overflow-x-auto">
      <table className="data-table">
        <thead>
          <tr>
            <th scope="col">Tool</th>
            <th scope="col" className="w-24">
              Risk
            </th>
            <th scope="col" className="w-20 text-right">
              Calls
            </th>
            <th scope="col" className="w-24 text-right">
              Success
            </th>
            <th scope="col" className="w-20 text-right">
              Failures
            </th>
            <th scope="col" className="w-56">
              p95 latency
            </th>
            <th scope="col" className="w-24 text-right">
              Median
            </th>
          </tr>
        </thead>
        <tbody>
          {tools.map((tool) => (
            <tr key={tool.tool_name}>
              <td className="mono text-ink">{tool.tool_name}</td>
              <td>
                {tool.risk ? (
                  <RiskBadge risk={tool.risk as 'READ' | 'WRITE' | 'DESTRUCTIVE' | 'META'} />
                ) : (
                  '—'
                )}
              </td>
              <td className="mono text-right text-ink-dim">{formatCount(tool.calls)}</td>
              <td className="mono text-right">
                {/* A tool that never executed has no success rate. Rendering 0% would make
                    a write tool that correctly stopped for approval look broken. */}
                {tool.success_rate === null || tool.success_rate === undefined ? (
                  <span className="text-ink-faint" title="Nothing executed in this window">
                    —
                  </span>
                ) : (
                  <span className={tool.success_rate === 1 ? 'text-ok' : 'text-ink-dim'}>
                    {formatPercent(tool.success_rate, 0)}
                  </span>
                )}
              </td>
              <td className="mono text-right">
                <span className={tool.failures > 0 ? 'text-fail' : 'text-ink-faint'}>
                  {tool.failures}
                </span>
              </td>
              <td>
                <LatencyBar totalMs={tool.latency.p95_ms} scaleMs={scaleMs} />
              </td>
              <td className="mono text-right text-ink-muted">{formatMs(tool.latency.p50_ms)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
